var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBolt = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.76022 0.626701C6.82049 0.26506 7.13338 0 7.50001 0H15.75C16.0158 0 16.2617 0.140621 16.3964 0.369654C16.5312 0.598688 16.5347 0.881934 16.4056 1.11423L13.4433 6.4465L19.3529 5.26456C19.6361 5.20793 19.9266 5.31891 20.0999 5.54991C20.2732 5.78091 20.2985 6.09089 20.165 6.34692L11.1649 23.5969C10.9959 23.9209 10.618 24.0759 10.2702 23.9639C9.9224 23.852 9.70587 23.5057 9.75755 23.1439L11.1042 13.7174L5.41271 14.9821C5.16934 15.0362 4.915 14.9658 4.73406 14.7943C4.55312 14.6228 4.46923 14.3726 4.51022 14.1267L6.76022 0.626701ZM8.13536 1.5L6.17257 13.2767L11.8373 12.0179C12.0777 11.9644 12.3289 12.0324 12.5096 12.1997C12.6903 12.367 12.7773 12.6123 12.7425 12.8561L11.8622 19.0177L18.11 7.04286L12.1471 8.23544C11.8604 8.29277 11.5666 8.17831 11.3942 7.94219C11.2219 7.70607 11.2024 7.39132 11.3444 7.13577L14.4754 1.5H8.13536Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBolt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bolt.5188ef23eb371bcef66c782d698f9d2d.svg";